import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=d856066c&"
import script from "./Wrapper.js?vue&type=script&lang=js&"
export * from "./Wrapper.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports